import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next'




function Advantages () {

    const { i18n, t } = useTranslation();

    return (
        <Container style={{marginTop: '30px'}}>
            <Row style={{ textAlign: 'center'}}>
                <Col md={12} xs={12}>
                    <h3>{t('advantageTitle')}</h3>
                </Col>
            </Row>
            <Row style={ { marginTop: '20px'} }>
                <Col md={4} xs={12}>
                    <h4>{t('advantageSubtitle1')}</h4>
                    <p>{t('advantageText1')}</p>
                </Col>
                <Col md={4} xs={12}>
                    <h4>{t('advantageSubtitle2')}</h4>
                    <p>{t('advantageText2')}</p>
                </Col>
                <Col md={4} xs={12}>
                    <h4>{t('advantageSubtitle3')}</h4>
                    <p>{t('advantageText3')}</p>
                </Col>
            </Row>
        </Container>
)
};

export default Advantages;